const STORAGE_PREFIX = 'gadkot_heritage_profile_';

export const HERITAGE_ERA_OPTIONS = [
  { id: 'SHIV_ERA', labelKey: 'register.eraShiv' },
  { id: 'PESHWA', labelKey: 'register.eraPeshwa' },
  { id: 'ANCIENT', labelKey: 'register.eraAncient' },
  { id: 'ALL', labelKey: 'register.eraAll' },
];

export const EMPTY_HERITAGE_PROFILE = {
  treksCompleted: 0,
  fortsVisited: 0,
  templesVisited: 0,
  wadasVisited: 0,
  heritageSitesVisited: 0,
  yearsExploring: 0,
  homeDistrict: '',
  favoriteEra: 'SHIV_ERA',
  bio: '',
};

export function normalizeHeritageProfile(raw = {}) {
  const num = (v) => {
    const n = Number.parseInt(String(v ?? ''), 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  };
  return {
    treksCompleted: num(raw.treksCompleted),
    fortsVisited: num(raw.fortsVisited),
    templesVisited: num(raw.templesVisited),
    wadasVisited: num(raw.wadasVisited),
    heritageSitesVisited: num(raw.heritageSitesVisited),
    yearsExploring: num(raw.yearsExploring),
    homeDistrict: String(raw.homeDistrict ?? '').trim(),
    favoriteEra: HERITAGE_ERA_OPTIONS.some((e) => e.id === raw.favoriteEra)
      ? raw.favoriteEra
      : 'SHIV_ERA',
    bio: String(raw.bio ?? '').trim().slice(0, 500),
    updatedAt: raw.updatedAt || new Date().toISOString(),
  };
}

export function getHeritageProfileStorageKey(userId) {
  return `${STORAGE_PREFIX}${userId}`;
}

export function loadHeritageProfile(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(getHeritageProfileStorageKey(userId));
    if (!raw) return null;
    return normalizeHeritageProfile(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function saveHeritageProfile(userId, profile) {
  if (!userId) return null;
  const normalized = normalizeHeritageProfile({
    ...profile,
    updatedAt: new Date().toISOString(),
  });
  localStorage.setItem(getHeritageProfileStorageKey(userId), JSON.stringify(normalized));
  return normalized;
}
